import MediaGalleryHorizontal from './MediaGalleryHorizontal';

export default MediaGalleryHorizontal;
